<template>
    <NuxtLink
        :to="url"
        class="base-banner"
    >
        <img
            v-if="image"
            class="base=banner__image"
            :src="image.src"
            :alt="image.alt || ''"
            loading="lazy"
        >
        <div class="base-banner__content">
            <slot />
        </div>
        <BaseIcon
            class="base-banner__arrow"
            icon="arrow-right"
        />
    </NuxtLink>
</template>

<script setup>
defineProps({
    url: {
        type: String,
        required: true,
        default: ''
    },
    image: {
        type: Object,
        required: false,
        default: null
    }
});
</script>

<style lang="less" src="./BaseBanner.less" />
